export default __webpack_public_path__ + "static/media/ic_glp_40.c9e2d776.svg";